import React, {
  Fragment,
  useEffect,
  useState,
  useMemo,
  useCallback,
} from "react";
import {
  Table,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  Modal,
  ModalHeader,
  Form,
  ModalBody,
  Label,
  Input,
  FormFeedback,
  Spinner,
} from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../../Components/Common/DeleteModal";
import ApproveModal from "../../../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
  useRowSelect,
} from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetClientState, getClient } from "../../../../store/client/action";
import { resetCompanyState, getCompany } from "../../../../store/company/action";
import {
  resetSurveyScoreState,
  getSurveyScore as onGetSurveyScores,
  addNewSurveyScore as onAddNewSurveyScore,
  updateSurveyScore as onUpdateSurveyScore,
  deleteSurveyScore as onDeleteSurveyScore,
  getSurveyScoreLoading,
} from "../../../../store/surveyScore/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ExportCSVModal from "../../../../Components/Common/ExportCSVModal";

const SurveyScore = () => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const dispatch = useDispatch();

  const {
    surveyScores,
    isSurveyScoreCreated,
    isSurveyScoreSuccess,
    loading,
    error,
    companies,
    companyLoading,
    clients,
    clientLoading,
  } = useSelector((state) => ({
    surveyScores: state.SurveyScore.surveyScores,
    isSurveyScoreCreated:
      state.SurveyScore.isSurveyScoreCreated,
    isSurveyScoreSuccess:
      state.SurveyScore.isSurveyScoreSuccess,
    loading: state.SurveyScore.loading,
    error: state.SurveyScore.error,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
  }));

  const [surveyScoreList, setSurveyScoreList] = useState([]);
  const [surveyScore, setSurveyScore] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [approveModal, setApproveModal] = useState(false);

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");
  const [companyName, setCompanyName] = useState({});
  const [clientName, setClientName] = useState({});

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];
  const onClickDelete = (surveyScore) => {
    setSurveyScore(surveyScore);
    setDeleteModal(true);
  };

  const handleDeleteSurveyScore = () => {
    if (surveyScore) {
      dispatch(onDeleteSurveyScore(surveyScore));
      setDeleteModal(false);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    setSurveyScoreList(surveyScores);
  }, [surveyScores]);

  useEffect(() => {
    if (!isEmpty(surveyScores)) {
      setSurveyScoreList(surveyScores);
    }
  }, [surveyScores]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      let filteredSurveyScores = surveyScores;
      if (type !== "all") {
        filteredSurveyScores = surveyScores.filter(
          (surveyScore) =>
            surveyScore.svs_status.name === type
        );
      }
      setSurveyScoreList(filteredSurveyScores);
    }
  };

  useEffect(() => {
    if (!isSearch) {
      dispatch(resetSurveyScoreState());
      dispatch(onGetSurveyScores());
      dispatch(resetClientState());
      dispatch(getClient());
      setIsSearch(true);
      const obj = JSON.parse(localStorage.getItem("authUser"));
      if (
        obj.data &&
        obj?.data?.user?.user_position &&
        obj?.data?.user?.user_position?.position_role
      ) {
        setCompanyName({
          label: obj?.data?.user.user_company.name,
          value: obj?.data?.user.user_company.id,
        });
        setClientName({
          label: obj?.data?.user.user_client.name,
          value: obj?.data?.user.user_client.id,
        });
        setRoles(obj?.data?.user?.user_position?.position_role);
      } else setRoles(null);

      if (obj?.data) setUserType(obj?.data?.userType);
    }
  }, [dispatch, surveyScores, isSearch]);

  useEffect(() => {
    setSurveyScore(surveyScores);
  }, [surveyScores]);

  useEffect(() => {
    if (!isEmpty(surveyScores)) {
      setSurveyScore(surveyScores);
      setIsEdit(false);
    }
  }, [surveyScores]);

  useEffect(() => {
    setSurveyScoreList(surveyScores);
  }, [surveyScores]);

  useEffect(() => {
    if (!isEmpty(surveyScores))
      setSurveyScoreList(surveyScores);
  }, [surveyScores]);

  // useEffect(() => {
  //   if (companies && !companies.length) {
  //     dispatch(resetCompanyState());
  //     dispatch(getCompany());
  //   }
  // }, [dispatch, companies]);

  function handleCompany(e) {
    if (e.length > 2) {
      const param = { title: e, status: 2 };
      dispatch(getCompany(param));
    }
    return false;
  }

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setSurveyScore(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleGetCompany = (id) => {
    dispatch(resetCompanyState());
    dispatch(getCompany({ clientId: id }));
  };

  const handleSurveyScoreClick = useCallback(
    (arg) => {
      const data = arg;

      setSurveyScore({
        id: data.id,
        description: data.description,
        amount_to: data.amount_to,
        amount_from: data.amount_from,
        name: data.name,
        company: {
          label: data.svs_company.name,
          value: data.svs_company.id,
        },
        client: {
          label: data.svs_client.name,
          value: data.svs_client.id,
        },
      });

      setIsEdit(true);
      toggle();
    },
    [toggle]
  );

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteSurveyScore(element.value));
    });
    checkall.checked = false;
  };

  const onClickApprove = (employee) => {
    setSurveyScore(employee);
    setApproveModal(true);
  };

  const handleApproveEmployee = () => {
    if (surveyScore) {
      surveyScore.setApprove = true;
      dispatch(onUpdateSurveyScore(surveyScore));
      dispatch(resetSurveyScoreState());
      dispatch(onGetSurveyScores());
      setApproveModal(false);
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: (
          <input
            type="checkbox"
            id="checkBoxAll"
            className="form-check-input"
            onClick={() => checkedAll()}
          />
        ),
        Cell: (cellProps) => {
          return (
            <input
              type="checkbox"
              className="dataCheckbox form-check-input"
              value={cellProps.row.original.id} />
          );
        },
        id: "#",
      },
      {
        Header: " ",
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <Link
                to="#"
                className={
                  userType === "admin"
                    ? "btn-icon btn btn-sm btn-light edit-item-btn"
                    : userRole &&
                      userRole.split(",").indexOf("updateSurveyScore") !==
                      -1
                      ? "btn-icon btn btn-sm btn-light edit-item-btn"
                      : "btn-icon btn btn-sm btn-light edit-item-btn d-none"
                }
                onClick={() => {
                  const surveyScoreData = cellProps.row.original;
                  handleSurveyScoreClick(surveyScoreData);
                }}>
                <i className="ri-edit-2-line fs-15"></i>
              </Link>
              <Link
                to="#"
                className={
                  userType === "admin"
                    ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn"
                    : userRole &&
                      userRole.split(",").indexOf("deleteSurveyScore") !==
                      -1
                      ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn"
                      : "btn-icon btn btn-sm btn-soft-danger remove-item-btn d-none"
                }
                onClick={() => {
                  const surveyScoreData = cellProps.row.original;
                  onClickDelete(surveyScoreData);
                }}>
                <i className="ri-delete-bin-line fs-15 text-danger"></i>
              </Link>
              {cellProps.row.original.statusId === 1 ? (
                <button
                  className={
                    userType === "admin"
                      ? "btn-label btn btn-sm btn-soft-success fs-12 me-0"
                      : userRole &&
                        userRole
                          .split(",")
                          .indexOf("approveSurveyScore") !== -1
                        ? "btn-label btn btn-sm btn-soft-success fs-12 me-0"
                        : "btn-label btn btn-sm btn-soft-success fs-12 me-0 d-none"
                  }
                  onClick={() => {
                    let data = cellProps.row.original;
                    onClickApprove(data);
                  }}><i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i>
                  Approve
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        Header: "Score Name",
        accessor: "name",
        filterable: true,
      },
      {
        Header: "Value From",
        accessor: "amount_from",
        filterable: true,
      },
      {
        Header: "Value To",
        accessor: "amount_to",
        filterable: true,
      },
      {
        Header: "Keterangan",
        accessor: "description",
        filterable: true,
      },
      {
        Header: "Status",
        accessor: "svs_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return (
                <span className="badge text-uppercase badge-soft-warning">
                  {cell.value}
                </span>
              );
            case "ACTIVE":
              return (
                <span className="badge text-uppercase badge-soft-info">
                  {cell.value}
                </span>
              );
            case "INACTIVE":
              return (
                <span className="badge text-uppercase badge-soft-danger">
                  {cell.value}
                </span>
              );
            default:
              return (
                <span className="badge text-uppercase badge-soft-warning">
                  {cell.value}
                </span>
              );
          }
        },
      },
    ],
    [handleSurveyScoreClick, userType, userRole]
  );

  const defaultdate = () => {
    return moment(new Date())

      .format("YYYY/MM/DD HH:mm:ss")
      .toString();
  };

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(new Date(date), "YYYY/MM/DD")

      .format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(new Date(time), "YYYY/MM/DD")

      .format("HH:mm");
  };

  //TABLE
  const {
    getTableProps, rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: surveyScoreList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,

      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable
      ? column.isSorted
        ? column.isSortedDesc
          ? " sorting_desc"
          : " sorting_asc"
        : " sort"
      : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);

  function handleFilter() {
    let amount_to = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr[1]) {
      amount_to = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var amount_from = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      amount_to: amount_to,
      endat: endat,
      amount_from: amount_from,
    };
    dispatch(onGetSurveyScores(param));
  }

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      description:
        (surveyScore && surveyScore.description) ?? "",
      amount_from:
        (surveyScore && surveyScore.amount_from) || 0,
      amount_to: (surveyScore && surveyScore.amount_to) | 0,
      name: (surveyScore && surveyScore.name) ?? "",
      company:
        userType !== "admin"
          ? companyName
          : surveyScore && surveyScore.company,
      client:
        userType !== "admin"
          ? clientName
          : surveyScore && surveyScore.client,
    },
    validationSchema: Yup.object({
      amount_from: Yup.string().required("Please Pick Value From"),
      amount_to: Yup.string().required("Please Pick Value From Date"),
      name: Yup.string().required("Please Enter Score Name"),
      company: Yup.object().required("Please Enter company").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getSurveyScoreLoading());
      if (isEdit) {
        const updateSurveyScore = {
          id: surveyScore ? surveyScore.id : 0,
          statusId: 1,
          description: values.description,
          amount_from: values.amount_from,
          amount_to: values.amount_to,
          name: values.name,
          companyId: values.company.value,
          clientId: values.client.value,
        };
        dispatch(onUpdateSurveyScore(updateSurveyScore));
        validation.resetForm();
      } else {
        const newSurveyScore = {
          statusId: 1,
          description: values.description,
          amount_from: values.amount_from,
          amount_to: values.amount_to,
          name: values.name,
          companyId: values.company.value,
          clientId: values.client.value,
        };
        dispatch(onAddNewSurveyScore(newSurveyScore));
        validation.resetForm();
      }
      toggle();
    },
  });

  document.title = "SurveyScores | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal
        show={isExportCSV}
        onCloseClick={() => setIsExportCSV(false)}
        data={surveyScoreList} />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteSurveyScore}
        onCloseClick={() => setDeleteModal(false)} />
      <ApproveModal
        data={surveyScore ? surveyScore.name : ""}
        show={approveModal}
        onApproveClick={handleApproveEmployee}
        onCloseClick={() => setApproveModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)} />
      <Container fluid>
        <BreadCrumb
          title="Score"
          pageTitle="Sales" />
        <Row>
          <Col lg={12}>
            <Card id="surveyScoreList">
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    Score &nbsp;
                    {isLoading ? (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;</>
                    ) : (
                      ""
                    )}
                  </h5>
                  <div className="flex-shrink-0">
                    <button
                      type="button"
                      className={
                        userType === "admin"
                          ? "btn btn-primary add-btn me-2"
                          : userRole &&
                            userRole
                              .split(",")
                              .indexOf("createSurveyScore") !== -1
                            ? "btn btn-primary add-btn me-2"
                            : "btn btn-primary add-btn me-2 d-none"
                      }
                      id="create-btn" onClick={() => {
                        setSurveyScore("");
                        setIsEdit(false);
                        toggle();
                      }}>
                      <i className="ri-star-line me-1 align-bottom fs-14"></i>Tambah
                    </button><button
                      type="button"
                      className="btn btn-success"
                      onClick={() => setIsExportCSV(true)}>
                      <i className="ri-file-download-line me-1 align-bottom fs-14"></i>Export
                    </button><button
                      className={
                        userType === "admin"
                          ? "btn btn-soft-danger"
                          : userRole &&
                            userRole
                              .split(",")
                              .indexOf("deleteSurveyScore") !== -1
                            ? "btn btn-soft-danger"
                            : "btn btn-soft-danger d-none"
                      }
                      onClick={() => setDeleteModalMulti(true)}>
                      <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i>Delete
                    </button>
                  </div>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Nav
                    className="nav-tabs nav-tabs-custom nav-success"
                    role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames(
                          { active: activeTab === "1" },
                          "fw-semibold"
                        )}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"><i className="ri-star-line me-1 align-bottom fs-14"></i>  All Scores
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames(
                          { active: activeTab === "2" },
                          "fw-semibold"
                        )}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"><i className="ri-information-line me-1 align-bottom fs-14"></i>  DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames(
                          { active: activeTab === "3" },
                          "fw-semibold"
                        )}
                        onClick={() => {
                          toggleTab("3", "ACTIVATED");
                        }}
                        href="#"><i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i>  ACTIVE</NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames(
                          { active: activeTab === "4" },
                          "fw-semibold"
                        )}
                        onClick={() => {
                          toggleTab("4", "DEACTIVATED");
                        }}
                        href="#"><i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i>  INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2} className="col-xxl-1">
                            <div className="me-2 mb-2 col-12">
                              <select
                                className="form-select"
                                value={pageSize}
                                onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={6}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Search...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={6} className="col-xxl-3">
                            <div className="search-box mb-2">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Select created date"
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div>
                              <button
                                type="button"
                                className="btn btn-light w-100"
                                onClick={() => {
                                  handleFilter();
                                }}>
                                <i className="ri-search-line me-1 align-bottom fs-14"></i>          Search
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table
                      hover
                      {...getTableProps()}
                      className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr
                            className={""}
                            key={index}
                            {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column, index) => (
                              <th
                                key={index}
                                className={"" + generateFilterable(column)}
                                {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          color="light"
                          onClick={previousPage}
                          disabled={!canPreviousPage}>
                          {"<"}  </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Page<strong>
                        {pageIndex + 1} of {pageOptions.length}
                      </strong>
                    </Col>
                    <Col className="col-md-auto">
                      <Input
                        type="number"
                        min={1}
                        style={{ width: 70 }}
                        max={pageOptions.length}
                        defaultValue={pageIndex + 1}
                        onChange={onChangeInInput}
                      />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={nextPage}
                          disabled={!canNextPage}>{">"}</Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit
                      ? "Edit Score"
                      : "Add Score"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <div className="row">
                        <div className="mb-3 col-lg-12">
                          <Label htmlFor="name-field" className="form-label">
                            Score Name    </Label>
                          <Input
                            name="name"
                            id="name-field"
                            className="form-control"
                            placeholder="Enter Score Name"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.name}
                            invalid={
                              validation.touched.name && validation.errors.name
                                ? true
                                : false
                            } />
                          {validation.touched.name && validation.errors.name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.name}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3 col-lg-6">
                          <Label
                            htmlFor="amount_from-field"
                            className="form-label">
                            Value From    </Label>
                          <Input
                            name="amount_from"
                            id="amount_from-field"
                            className="form-control"
                            placeholder="Enter Value From"
                            type="number"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.amount_from}
                            invalid={
                              validation.touched.amount_from &&
                                validation.errors.amount_from
                                ? true
                                : false
                            } />
                          {validation.touched.amount_from &&
                            validation.errors.amount_from ? (
                            <FormFeedback type="invalid">
                              {validation.errors.amount_from}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3 col-lg-6">
                          <Label
                            htmlFor="amount_to-field"
                            className="form-label">
                            Value To    </Label>
                          <Input
                            name="amount_to"
                            id="amount_to-field"
                            className="form-control"
                            placeholder="Enter Value To"
                            type="number"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.amount_to}
                            invalid={
                              validation.touched.amount_to &&
                                validation.errors.amount_to
                                ? true
                                : false
                            } />
                          {validation.touched.amount_to &&
                            validation.errors.amount_to ? (
                            <FormFeedback type="invalid">
                              {validation.errors.amount_to}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <Label htmlFor="client-field" className="form-label">
                            Grup Usaha&nbsp;
                            {clientLoading ? (
                              <Spinner color="primary" size="sm">
                                Loading...
                              </Spinner>
                            ) : (
                              ""
                            )}
                          </Label>
                          <Select
                            name="client"
                            value={validation.values.client}
                            placeholder="Pilih Grup Usaha"
                            onChange={(e) => {
                              setCompanyList([]);
                              validation.setFieldValue("client", e);
                              handleGetCompany(e.value);
                            }}
                            options={clientList}></Select>
                        </div>

                        <div className="mb-3 col-lg-12">
                          <Label htmlFor="company" className="form-label">
                            Company      {companyLoading && (
                              <Spinner color="primary" size="sm">
                                Loading...
                              </Spinner>
                            )}
                          </Label>
                          <Select
                            name="company"
                            placeholder="Enter Company"
                            value={validation.values.company}
                            isDisabled={userType === "admin" || userType === "client" || userType === "company" ? false : true}
                            onChange={(e) => {
                              validation.setFieldValue("company", e);
                            }}
                            onInputChange={(e) => {
                              handleCompany(e);
                            }}
                            options={companyList}></Select>
                          {validation.touched.company &&
                            validation.errors.company ? (
                            <small className="text-danger" type="invalid">
                              {validation.errors.company}
                            </small>
                          ) : null}
                        </div>
                        <div className="mb-3 col-lg-12">
                          <Label
                            htmlFor="description-field"
                            className="form-label">
                            Description
                          </Label>
                          <Input
                            name="description"
                            id="description-field"
                            rows="4"
                            className="form-control"
                            placeholder="Isi Keterangan"
                            type="textarea"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.description} />
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}>
                          Close
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">
                              {!!isEdit
                                ? "Update"
                                : "Add Score"}
                            </span>
                            {loading ? (
                              <Spinner size="sm" className="flex-shrink-0">
                                Loading...
                              </Spinner>
                            ) : (
                              ""
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SurveyScore;
